import React from 'react';

const TeamSelector = ({ teams = [], selectedCode, onChange }) => {
  return (
    <div className="col-12 mb-3 text-start">
      <label htmlFor="favourite-club" className="form-label text-dark fw-medium mb-2 white-bg">
        Favourite Club <span className="text-danger">*</span>
      </label>
      <select
        id="favourite-club"
        className="form-select w-100 white-bg border-1 rounded-sm py-3 px-3"
        value={selectedCode}
        onChange={(event) => onChange(event.target.value)}
        disabled={!teams.length}
        required
      >
        <option value="">{teams.length ? 'Select favourite club' : 'Loading clubs...'}</option>
        {teams.map((team) => (
          <option key={team.short_code} value={team.short_code}>
            {team.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TeamSelector;
